<template>
    <div class="news-nav-top" >
        <h3>新闻快讯</h3>
        <ul>
            <li @click="newsShow(item.id)" v-for="item in hyNews" :key="item.id"><i class="iconfont icon-youjiantoushixinxiao"></i>{{item.title}}</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'NewsNavTop',
    props:{
        hyNews: Array
    },
    data () {
        return {
            
        }
    },
    methods: {
        newsShow (id) {
            this.$router.push('/newsdetail/'+id);
        }
    }
}
</script>

<style lang="stylus" scoped>
    @import '~styles/mixins.styl'
    @import '~styles/varible.styl'
    .news-nav-top
        box-sizing: border-box
        background-color: #fff 
        border: 1px solid #ccc
        width: 100%
        padding: 56px 48px 59px
        margin-bottom: 15%
        color: #333
        h3
            font-size: 18px
            font-weight: 600
            margin-bottom: 46px
            letter-spacing: 1px
        ul
            color: #666
            li
                cursor: pointer
                font-size: 14px
                margin: 0
                line-height: 50px
                line-ellipsis()
                i
                    line-height: 50px
                    transform: scale(0.5)
                    margin-right: 6px
            li:last-of-type
                margin-bottom: 0
</style>


// WEBPACK FOOTER //
// src/components/pc/NewsNavTop.vue